
import { useWindowSizeFn } from '@/hooks/useWindowSizeFn'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'MFooter',
  setup() {
    const contentWeight = ref(window.innerWidth)
    const isShowMobile = ref(false)
    useWindowSizeFn(
      () => {
        contentWeight.value = window.innerWidth
        if (contentWeight.value <= 825) {
          isShowMobile.value = true
          return
        }
        isShowMobile.value = false
      },
      200,
      { immediate: true }
    )

    return {
      isShowMobile,
      contentWeight
    }
  }
})
